// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-terms-conditions',
//   standalone: true,
//   imports: [],
//   templateUrl: './terms-conditions.html',
//   styleUrl: './terms-conditions.css',
// })
// export class TermsConditions {}


import { Component, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';

interface TermsItem {
  ID: number;
  Title: string;
  IconClass: string;
  Content: string;       // HTML
  DisplayOrder: number;
}

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [],
  templateUrl: './terms-conditions.html',
  styleUrl: './terms-conditions.css',
})
export class TermsConditions implements OnInit {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);

  private readonly apiBase = 'https://crm-api.redmonkwellness.com';

  sections = signal<TermsItem[]>([]);
  loading = signal(true);
  error = signal(false);

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;   // API call only in the browser

    this.http
      .post<{ success: boolean; Items: TermsItem[] }>(
        `${this.apiBase}/TimelessMonk/GetTerms`,
        {}
      )
      .subscribe({
        next: (res) => {
          if (res.success) this.sections.set(res.Items || []);
          else this.error.set(true);
          this.loading.set(false);
        },
        error: (err) => {
          console.error('Terms load failed:', err);
          this.error.set(true);
          this.loading.set(false);
        },
      });
  }
}